import React from "react";




export default class PageBar extends React.PureComponent {


    static defaultProps = {
        showPagination: true,
        handleLimitChange: () => null
    }


    render() {

        let {pullOffset, pullLimit} = this.props;

        return (
            <div className={'my-3'}>
                <nav className={'level'}>
                    <div className={'level-left'}>
                        <div className={'level-item'}>
                                <span
                                    className={`icon has-text-info ${this.props.pullOffset === 0 ? 'disable' : ''}`}
                                    onClick={() => this.props.handleOffsetChange(
                                        this.props.pullOffset - this.props.pullLimit > 0 ? this.props.pullOffset - this.props.pullLimit : 0
                                    )}
                                >
                                    <i className="fas fa-arrow-left"/>
                                </span>
                        </div>
                        <div className={'level-item has-text-grey-light'}>
                            Displaying: {pullLimit === this.props.data.length ?
                            `${pullOffset + 1} - ${pullOffset + pullLimit}` :
                            `${pullOffset + 1} - ${pullOffset + this.props.data.length}`}
                        </div>
                    </div>
                    {!!this.props.showPagination &&
                        <div className={'level-right'}>
                            <div className={'level-item has-text-grey-light'}>
                                Show:
                            </div>
                            <div className={'level-item'}>
                                <nav className="breadcrumb" aria-label="breadcrumbs">
                                    <ul>
                                        {[25, 50, 100].map(d => (
                                            <li
                                                className={this.props.pullLimit === d ? 'is-active' : 'has-text-grey-light'}
                                                onClick={() => this.props.handleLimitChange(d)}
                                            >
                                                <a style={{color: 'inherit'}}>{d}</a>
                                            </li>
                                        ))}
                                    </ul>
                                </nav>
                            </div>
                            <div className={'level-item'}>
                                <span
                                    className={`icon has-text-info ${this.props.data.length < this.props.pullLimit ? 'disable' : ''}`}
                                    onClick={() => this.props.handleOffsetChange(this.props.pullOffset + this.props.pullLimit)}
                                >
                                    <i className="fas fa-arrow-right"/>
                                </span>
                            </div>
                        </div>
                    }
                </nav>
            </div>
        )
    }

}
